'use strict';
'use es6';

// ⚠️ Hello HubSpotters, Please don't import from this module. ☠️

Object.defineProperty(exports, "__esModule", {
  value: true
});
var uniqueIdCounter = 0;

/** @returns {string} a unique id string with the given prefix */
var uniqueId = function uniqueId(prefix) {
  return '' + (prefix == null ? '' : prefix) + ++uniqueIdCounter;
};

/** @returns {boolean} whether the given value is the constant NaN */
var isNaN = function isNaN(value) {
  return typeof value === 'number' && value !== +value;
};

/** @returns {*} the first element of an Array or NodeList */
var first = function first(list) {
  return list == null || list.length === 0 ? undefined : list[0];
};

/** @returns {*} the last element of an Array or NodeList */
var last = function last(list) {
  return list == null || list.length === 0 ? undefined : list[list.length - 1];
};

exports.first = first;
exports.isNaN = isNaN;
exports.last = last;
exports.uniqueId = uniqueId;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.3620/js/utils/underscore/index.js
// module id = 25
// module chunks = 177